import { Image } from '@cian/ui-kit';
import { IconPlaceholderImage16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { IFavoriteEntity } from '../../../types/favoriteEntity';
import { PublicationRemovalNotice } from '../../PublicationRemovalNotice';

interface IImagesProps {
  offer: IFavoriteEntity;
}

export const Images: React.FC<IImagesProps> = ({ offer }) => {
  const { photoPreviewUrl, fullUrl, status, deleteDate } = offer;

  return (
    <div className={styles['container']}>
      <a href={fullUrl} target="_blank" rel="noreferrer">
        {photoPreviewUrl ? (
          <Image
            src={photoPreviewUrl}
            width={288}
            height={162}
            borderRadius="4px"
            alt="Главное фото объявления"
            objectFit="cover"
          />
        ) : (
          <div className={styles['empty_photo']}>
            <IconPlaceholderImage16 color="gray20_100" />
          </div>
        )}
      </a>
      <PublicationRemovalNotice status={status} deleteDate={deleteDate} isMap={true} />
    </div>
  );
};
